import React from "react"
import {CelebrationTag, CelebrationTagKind} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import AutomationItem from "./AutomationItem"
import {useCelebrationTagsQuery} from "@irati/recognition/hooks"

const AutomationsList = () => {
  const {data: celebrationTags, loading} = useCelebrationTagsQuery({
    kind: CelebrationTagKind.Automation
  })
  if (loading || !celebrationTags) {
    return null
  }
  return (
    <Flex direction="column" gap={3}>
      {celebrationTags.map((automation: CelebrationTag) => (
        <AutomationItem key={automation.uuid} automation={automation} />
      ))}
    </Flex>
  )
}
export default AutomationsList
